module.exports = __webpack_public_path__ + "static/img/diamond.67f16f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/leagueoflegends/ranks/diamond.png
// module id = acqG
// module chunks = 35